<template>
  <BModal
    v-slot="{ modal }"
    name="fast-contact-modal"
    dialog-class="max-w-2xl pt-4 relative"
    @open="initStep"
    @close="close()"
  >
    <FastHeader @close="close(modal)">
      <template #title>
        <h2 id="fast-contact-title" class="m-0 text-center text-2xl font-medium leading-none text-neutral-700"></h2>
      </template>
      <template #wizard>
        <Wizard v-if="isGuest && wizardProgressValue" :value="wizardProgressValue" />
      </template>
    </FastHeader>
    <form
      id="fast-contact-form"
      class="p-8 pt-0"
      method="post"
      action="/api/conversations"
      @submit.prevent
      @keydown.enter.prevent
    >
      <component :is="steps[step]" v-if="step" :is-guest="isGuest" @goto="step = $event" />
    </form>
  </BModal>
</template>

<script setup>
import { computed, getCurrentInstance, ref, watch } from 'vue'
import BModal from '@/apps/shared/components/b-modal.vue'
import Wizard from './components/Wizard.vue'
import MessageStep from './components/MessageStep.vue'
import UserContactStep from './components/UserContactStep.vue'
import SignupLoginStep from './components/SignupLoginStep.vue'
import SuccessStep from './components/SuccessStep.vue'
import ConfirmationStep from './components/ConfirmationStep.vue'
import SpamStep from './components/SpamStep.vue'
import FastHeader from '../shared/components/FastHeader.vue'
import { useMainStore } from './stores/main'
const store = useMainStore()

const steps = {
  message: MessageStep,
  userContact: UserContactStep,
  signupLogin: SignupLoginStep,
  success: SuccessStep,
  confirmation: ConfirmationStep,
  spam: SpamStep
}

const close = modal => {
  if (modal) modal.hide()
  if (['confirmation', 'success'].includes(step.value)) {
    store.resetAll()
    step.value = 'message'
  }
}

const currentInstance = getCurrentInstance()
const rootInstance = currentInstance.root

const step = ref(null)
const isGuest = !rootInstance.data.currentUserId
if (rootInstance.data.quotaExceeded) {
  step.value = 'spam'
} else if (rootInstance.data.createdConversationId) {
  step.value = 'success'
}

watch(step, value => {
  window._paq.push(['FormAnalytics::scanForForms', currentInstance.proxy.$el.querySelector('#fast-contact-form')])
  window._paq?.push(['setCustomUrl', `/fast-contact/${value}`])
  window._paq?.push(['trackPageView'])
})

const wizardProgressValue = computed(() => {
  switch (step.value) {
    case 'message':
      return 33
    case 'userContact':
      return 66
    case 'signupLogin':
      return 80
    case 'confirmation':
      return 100
    default:
      return false
  }
})

// * step ref is not initialized when rendering because we want to run the onMounted hook of MessageStep.vue when users open the modal
function initStep() {
  if (step.value) return
  step.value = Object.keys(steps)[0]
}
</script>
